<template>
<el-row>
    <!-- h5>幫助中心</h5 -->
    <div class="help-left-title">幫助中心</div>
    <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" :router="true">

      <el-menu-item index="/help/cate1"><span slot="title">登錄註冊</span></el-menu-item>
      <el-menu-item index="/help/cate2"><span slot="title">存款流程</span></el-menu-item>
      <el-menu-item index="/help/cate3"><span slot="title">提款流程</span></el-menu-item>
      <el-menu-item index="/help/cate4"><span slot="title">轉帳流程</span></el-menu-item>
      <el-menu-item index="/help/cate5"><span slot="title">帳戶安全</span></el-menu-item>
      <el-menu-item index="/help/cate6"><span slot="title">會員制度</span></el-menu-item>
      <el-menu-item index="/help/cate7"><span slot="title">銀行相關</span></el-menu-item>
      <el-menu-item index="/help/cate8"><span slot="title">其它問題</span></el-menu-item>
    </el-menu>

</el-row>
</template>
<script>
  export default {
    methods: {
      handleOpen(key, keyPath) {
        console.log(key, keyPath);
      },
      handleClose(key, keyPath) {
        console.log(key, keyPath);
      }
    },
    data() {

	  return {
        activeIndex: this.$router.currentRoute.path,

      };
    },


  }
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/help/Menu.vue